import React from "react"
//import I18n from "i18n-js/index.js.erb"

class MyDialogDepricated extends React.Component {
  
  constructor(props) {
    super(props);

    this.onCancel = this.onCancel.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
  }

  componentDidMount() {
    $(this.refs.modal).modal();
  }

  /**
  * Render functions
  */

  render() {
    return (
      <div className={"modal MyDialog " + (typeof this.props.modalClasses != 'undefined' ? this.props.modalClasses : '')} ref="modal">
        <div className="modal-dialog modal-sm">
          <div className="modal-content">
            <div className="modal-header">
              <button type="button" className="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
              <h4 className="modal-title text-left">{this.props.title}</h4>
            </div>
            <div className="modal-body text-left">
              {this.props.children}
            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-dark" onClick={this.onCancel}>{I18n.t('cancel')}</button>
              <button type="button" className="btn btn-primary" onClick={this.onSubmit}>{I18n.t('submit')}</button>
            </div>
          </div>
        </div>
      </div>
    );
  };



  /**
  * Event handlers
  */

  onCancel() {
    this.hide();
    
    if (typeof this.props.onCancel == 'function') {
      this.props.onCancel();
    }
  }

  onSubmit() {
    if (typeof this.props.onSubmit == 'function') {
      this.props.onSubmit();
    }
  }



  /**
  * Helper functions
  */

  hide() {
    $(this.refs.modal).modal('hide');
  }

  show() {
    $(this.refs.modal).modal('show');
  }
};

export default MyDialog